<div class="ui-view-main">

    <ng-container *ngIf="items.length > 0">
        <div class="container no-padding">

            <div class="row">
                <div class="col-8">
                    <game-logo [guest]="guest" [logoSize]="logoSize"></game-logo>
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <a routerLink="/"
                       class="btn-txt"
                       [innerHTML]="'general.buttons.back' | translate"
                       play-audio
                       onEnterSound="btn_back_enter"
                       onClickSound="btn_back_click"
                    ></a>
                </div>
                <div class="col-8 col-offset-2">
                    <h2 class="align-center"><span [innerHTML]="contentCategoryTitle | translate"></span></h2>
                </div>
            </div>

            <div class="row">
                <div class="col-10 col-offset-1">

                    <div class="content-item"  *ngFor="let item of items;">
                        <h3>{{ item.title }}</h3>
                        <div class="content-text">
                            <markdown-text [text]="item.text"></markdown-text>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <a routerLink="/"
                       class="btn-txt"
                       [innerHTML]="'general.buttons.back' | translate"
                       play-audio
                       onEnterSound="btn_back_enter"
                       onClickSound="btn_back_click"
                    ></a>
                </div>
            </div>


        </div>
    </ng-container>

</div>